import { Tooltip } from 'antd';
import { EyeOutlined, LoadingOutlined, WarningFilled } from '@ant-design/icons';
import IconButton from 'components/new-ui/base/icon-button/IconButton';

type Props = {
    previewLoading: boolean;
    onPreview?: () => void;
};

const PreviewAction = ({ onPreview, previewLoading }: Props) => {
    if (!onPreview) {
        return (
            <Tooltip title="Download link is not available for this document">
                <WarningFilled style={{ color: 'var(--warning-normal)', fontSize: 16 }} />
            </Tooltip>
        );
    }

    return (
        <IconButton
            tooltipText="Preview"
            icon={previewLoading ? <LoadingOutlined /> : <EyeOutlined />}
            disabled={previewLoading}
            disabledText="Loading preview..."
            onClick={onPreview}
        />
    );
};

export default PreviewAction;
